import React, { useCallback, useState } from "react";
import { Entity } from "@common/types/entity";
import { StandardModalHeader } from "@design-system/Modal/Modal";
import { HStack } from "@design-system/HStack/HStack";
import { VStack } from "@design-system/VStack/VStack";
import { Button } from "@design-system/Button/Button";
import { useEntities } from "@hooks/useEntities";
import { AccountingEntitySelect } from "./AccountingEntitySelect";
import styles from "./AccountingMigrationModal.module.scss";

interface SelectMigrationEntityProps {
    initialEntityId: number | undefined;
    onSubmit: (entityId: number) => void;
}

export const SelectMigrationEntity: React.FC<SelectMigrationEntityProps> = ({
    initialEntityId,
    onSubmit,
}) => {
    const entities = useEntities({
        onlyBusiness: true,
        excludeMockEntities: true,
    });

    const [selectedEntity, setSelectedEntity] = useState<Entity | undefined>(
        () => entities.find((entity) => entity.id === initialEntityId),
    );

    const handleContinue = useCallback(() => {
        if (selectedEntity) {
            onSubmit(selectedEntity.id);
        }
    }, [selectedEntity, onSubmit]);

    return (
        <>
            <StandardModalHeader>
                <VStack gap={4}>
                    <span className={styles.stepLabel}>Step 1 of 3</span>
                    <div>Select entity</div>
                </VStack>
            </StandardModalHeader>
            <VStack gap={24}>
                <VStack gap={16}>
                    <div className={styles.description}>
                        Choose the entity you want to migrate accounting data
                        for
                    </div>
                    <AccountingEntitySelect
                        entities={entities}
                        selectedEntity={selectedEntity}
                        onChange={setSelectedEntity}
                    />
                </VStack>
                <HStack gap={8} justify="end">
                    <Button
                        variant="primary"
                        size="md"
                        onClick={handleContinue}
                        disabled={!selectedEntity}
                    >
                        Continue
                    </Button>
                </HStack>
            </VStack>
        </>
    );
};
